module.exports = __webpack_public_path__ + "static/media/Insta-timelapse-2.05c56e49.mp4";